import PropTypes from 'prop-types';
import { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { useSidebarContext } from './SidebarContext';

function MainLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { isCompact } = useSidebarContext();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header adaptatif */}
      <Header onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />

      {/* Container principal */}
      <div className="flex flex-1">
        {/* Sidebar adaptatif */}
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

        {/* Contenu principal */}
        <main
          className={`flex-1 bg-[#F9FBFD] px-4 pb-4 sm:px-6 sm:pb-6 lg:px-8 lg:pb-8 pt-20 transition-all duration-300 scrollbar-hide ${
            sidebarOpen ? (isCompact ? 'lg:ml-10' : 'lg:ml-60') : 'lg:ml-0'
          }`}
        >
          {children}
        </main>
      </div>
    </div>
  );
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;